
export {} from '@clayui/time-picker';
import __x__ from '@clayui/time-picker';export default __x__;